import React, { createContext, useState, useContext } from 'react';
import { TicketsFilterFormModel } from '../models/ticket.model';
import { TICKET_COMPANY_ALL, TICKET_ELEMENT_ALL, TICKET_PRIORITY_ALL, TICKET_STATUS_OPEN } from '../assets/appConstants/constants';
import { useProject } from './ProjectContext';

interface TicketsFilterContextType {
  ticketsFilter: TicketsFilterFormModel | undefined
  setTicketsFilter: (form: TicketsFilterFormModel | undefined) => void
  defaultTicketsFilter: TicketsFilterFormModel
  setDefaultTicketsFilter: () => void
  checkAppliedFilters: (form: TicketsFilterFormModel) => void
  appliedFilters: { 'key': string, 'value': string }[]
}

const TicketsFilterContext = createContext<TicketsFilterContextType | undefined>(undefined);

export const TicketsFilterProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { selectedProject } = useProject()

  const defaultTicketsFilter: TicketsFilterFormModel = {
    number: '',
    status: TICKET_STATUS_OPEN,
    priority: TICKET_PRIORITY_ALL,
    company: TICKET_COMPANY_ALL,
    element: TICKET_ELEMENT_ALL,
    alarm: '',
    from: '',
    to: '',
    project_id: selectedProject
  }

  const [ticketsFilter, setTicketsFilter] = useState<TicketsFilterFormModel | undefined>(defaultTicketsFilter);

  const setDefaultTicketsFilter = () => setTicketsFilter(defaultTicketsFilter)

  const [appliedFilters, setAppliedFilters] = useState<{ 'key': string, 'value': string }[]>([])

  const checkAppliedFilters = (filter: TicketsFilterFormModel) => {
    let filters = []
    let filter_value = ''
    let key, value: any
    for ([key, value] of Object.entries(filter)) {
      if (key === 'number' && typeof value === 'object') continue
      if (key !== 'project_id' && value !== '' && value['id'] !== 'ALL') {
        filter_value = typeof value === 'string' ? value : value.label
        filters.push({ 'key': key, 'value': filter_value })
      }
    }
    setAppliedFilters(filters)
  }

  return (
    <TicketsFilterContext.Provider value={{ ticketsFilter, setTicketsFilter, defaultTicketsFilter, setDefaultTicketsFilter, checkAppliedFilters, appliedFilters }}>
      {children}
    </TicketsFilterContext.Provider>
  );
};

export const useTicketsFilterContext = () => {
  const context = useContext(TicketsFilterContext);
  if (!context) {
    throw new Error('useTicketsFilter must be used inside a TicketsFilterProvider');
  }
  return context;
};